import React, {Component} from "react";
import {GoogleApiWrapper, Map, Polygon} from "google-maps-react";
import PropTypes from "prop-types";

const propTypes = {
	color: PropTypes.string,
	coords: PropTypes.array
}

class AreaMap extends Component {
	render() {
		return <Map google={this.props.google}
		            className="map-square"
		            initialCenter={{
						lat: 19.46,
						lng: -99.15
					}}
		            zoom={13}>
			{this.props.coords && <Polygon
				paths={this.props.coords}
				strokeColor={this.props.color}
				strokeOpacity={1}
				strokeWeight={2}
				fillColor={this.props.color}
				fillOpacity={0.35}
			/>}
		</Map>
	}
}

AreaMap.propTypes = propTypes;

export default GoogleApiWrapper({
	apiKey: 'AIzaSyBnmueHJLnp1vFFDs_GopXL_VdHPecHFXQ'
})(AreaMap);


// WEBPACK FOOTER //
// ./src/cdm-frontend/elements/maps/area-maps.jsx